import { render, staticRenderFns } from "./OnboardingCards.vue?vue&type=template&id=548cef35&scoped=true&"
import script from "./OnboardingCards.vue?vue&type=script&lang=js&"
export * from "./OnboardingCards.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingCards.vue?vue&type=style&index=0&id=548cef35&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548cef35",
  null
  
)

export default component.exports